export function getView(user, email) {
  return !user || !user.account
    ? 'NotInvited'
    : user.account.email !== email
    ? 'No'
    : user.account.active
    ? 'Active'
    : 'Inactive'
}
